export function focusOnPrevElement() {
  const focussableElements = 'a:not([disabled]), button:not([disabled]), input[type=text]:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])';
  const focussable = Array.prototype.filter.call(document.querySelectorAll(focussableElements), function (element) {
    return element.offsetWidth > 0 || element.offsetHeight > 0 || element === document.activeElement;
  });
  const index = focussable.indexOf(document.activeElement);
  focussable[index - 1].focus();
}
//# sourceMappingURL=focus.js.map